import { Instance, types } from "mobx-state-tree";


export const CustomProjectPropertyOptionModel = types.model({
  id: types.optional(types.number, 0),
  name: types.optional(types.string, ''),
  position: types.optional(types.number, 0),
  label: types.optional(types.string, ''),
  value: types.frozen()
});
export type CustomProjectPropertyOption = Instance<typeof CustomProjectPropertyOptionModel>;
